/** Returns a random integer within the provided range. Default: 0 - 1000000 */
export function random(start = 0, end = 1000000) {
    return Math.floor(Math.random() * end) + start;
}
